module.exports = __webpack_public_path__ + "static/elevation-shadows-dont-b18cd62645a6ffd180c3430a89ff5ec2.png";